import { render, staticRenderFns } from "./DashboardReferral.vue?vue&type=template&id=3c682667&scoped=true&"
import script from "./DashboardReferral.vue?vue&type=script&lang=js&"
export * from "./DashboardReferral.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReferral.vue?vue&type=style&index=0&id=3c682667&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c682667",
  null
  
)

export default component.exports